import { render, staticRenderFns } from "./ApprovedTag.vue?vue&type=template&id=48e501a0"
import script from "./ApprovedTag.vue?vue&type=script&lang=js"
export * from "./ApprovedTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports